import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Input,
  Injector,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClickableCardOverlayComponent } from './clickable-card.component';

@Directive({
  selector: '[appClickableCard]'
})
export class ClickableCardDirective implements OnInit, OnDestroy {

  @Input() clickableHint: string =
    this.translate.instant('ClickableCard.seeDetails');

  @Input() disabled = false;

  private overlayRef!: ComponentRef<ClickableCardOverlayComponent>;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private translate: TranslateService,
    private cfr: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  ngOnInit() {
    const host = this.el.nativeElement;
    this.renderer.setStyle(host, 'position', 'relative');
    this.renderer.setStyle(host, 'overflow', 'hidden');

    const factory = this.cfr.resolveComponentFactory(ClickableCardOverlayComponent);
    this.overlayRef = factory.create(this.injector);

    this.overlayRef.instance.hint = this.clickableHint;
    this.overlayRef.instance.visible = false;

    this.appRef.attachView(this.overlayRef.hostView);

    const overlayEl = (this.overlayRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    this.renderer.appendChild(host, overlayEl);
  }

  ngOnDestroy() {
    this.appRef.detachView(this.overlayRef.hostView);
    this.overlayRef.destroy();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.disabled) {
      this.overlayRef.instance.visible = true;
      this.overlayRef.changeDetectorRef.detectChanges();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.overlayRef.instance.visible = false;
    this.overlayRef.changeDetectorRef.detectChanges();
  }
}
